import { Chip } from "@mui/material";
import { popAnimation } from "./animations/pop";

const getDiscountPercentage = (originalPrice: number, discountPrice: number) => {
    if (originalPrice <= discountPrice) return 0; // No discount if price is equal or higher
    return Math.round(((originalPrice - discountPrice) / originalPrice) * 100);
  };


export const DiscountPill = ({ originalPrice, discountPrice }: { originalPrice: number; discountPrice: number }) => {
    const discountPercentage = getDiscountPercentage(originalPrice, discountPrice);

    if (discountPercentage === 0) return null; // No pill if no discount

    const shouldAnimate = discountPercentage > 50;

    const backgroundColor = shouldAnimate ? "#D32F2F" : "#A6C48A";
    const textColor = shouldAnimate ? "#fff" : "#000"; // <-- dynamic

    return (
      <Chip
      label={`${discountPercentage}% OFF`}
      sx={{
        backgroundColor: backgroundColor,
        color: textColor,
        borderRadius: '16px',
        margin: "4px",
        fontWeight: 'bold',
        fontSize: '0.8rem',
        animation: shouldAnimate ? `${popAnimation} 1s ease-in-out infinite` : undefined,
      }}/>
    );
  };